module.exports = __webpack_public_path__ + "static/media/programming.1f3eb97f.svg";